import { normalizeAgentIdentityValue } from '../../../common/utils/normalizeAgentIdentityValue';

/**
 * @deprecated Prefer importing `normalizeAgentIdentityValue` directly from
 * `../../../common/utils/default-agent` in new code.
 *
 * Note: this re-export expands the filtering contract compared to the previous
 * inline implementation. It now strips both the default-agent named-id sentinel
 * (`DEFAULT_AGENT_NAMED_ID = 'ai_mate_agent'`) and the default-agent runtime UUID
 * (`DEFAULT_AGENT_UUID`). Callers that previously passed the default-agent UUID
 * as a specialist id will now receive `undefined` from this function.
 */
export const normalizeIdentityValue: (value?: string | null) => string | undefined =
	normalizeAgentIdentityValue;
